import React from 'react'

import './style.css'

export default function Spinner({
  centered= false,
  color= '#0d83ff',
  padding= 0 as number | string,
  size= 20 as number | string,
  thickness= 0.6,
  inline= false,
}) {
  const spinner = (
    <div
      className="box"
      style={{ height: size, width: size }}
    >
      <div
        className="eclipse"
        style={{ boxShadow: `0 ${thickness}px 0 0 ${color}` }}
      />
    </div>
  )

  return (
    <div
      className={'spinner' + (centered ? ' centered' : '') + (inline ? ' inline' : '')}
      style={{padding}}
    >
      {spinner}
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/components/Spinner/index.tsx